import {Injectable} from '@angular/core';
import {Config} from '../../shared/services/config.service';

@Injectable()
export class AppProvider {
  private readonly _version: string = null;
  private readonly _mode: string = null;
  private readonly _app: string = null;
  private readonly _web: boolean = null;
  private readonly _storeAndroid: string = null;
  private readonly _storeAndroidV2: string = null;
  private readonly _storeIos: string = null;
  private readonly _storeIosV2: string = null;
  private regexpNumber: RegExp = /^(\d+\.)(\d+\.)(\d+\.)(\d+)$/;
  private regexpNumber2: RegExp = /^(\d+\.)(\d+\.)(\d+)$/;
  private regexpNumber3: RegExp = /^(\d+\.)(\d+)$/;
  private _packageName: string;

  constructor(private readonly config: Config) {
    const version = config.getConfig('version');
    this._mode = config.getConfig('mode');
    this._app = config.getConfig('app')
    this._web = config.getConfig('web');
    this._storeAndroid = config.getConfig('stores')['android'];
    this._storeAndroidV2 = config.getConfig('stores')['androidV2'];
    this._storeIos = config.getConfig('stores')['ios'];
    this._storeIosV2 = config.getConfig('stores')['iosV2'];
    // the regex ensure that older version number will be exlude, nnly semantic versioning is allowed.
    // @see https://semver.org/
    if (true === this.regexpNumber.test(version)) { // si 3.10.0.1
      this._version = version;
    } else if (true === this.regexpNumber2.test(version)) { // si 3.10.0
      this._version = version;
    } else if (true === this.regexpNumber3.test(version)) { // si 3.10 ==> on rajoute le .0
      this._version = version + '.0';
    } else {
      alert('VERSION MAL FORMATTEE : ' + version);
    }

    this._packageName = config.getConfig('packageName');
  }

  get version(): string | null {
    return this._version;
  }

  get mode(): string | null {
    return this._mode;
  }

  get web(): boolean | null {
    return this._web;
  }

  get packageName(): string {
    return this._packageName;
  }

  get app(): string {
    return this._app;
  }

  get storeAndroid(): string {
    return this._storeAndroid;
  }

  get storeIos(): string {
    return this._storeIos;
  }

  get storeAndroidV2(): string {
    return this._storeAndroidV2;
  }

  get storeIosV2(): string {
    return this._storeIosV2;
  }
}



// WEBPACK FOOTER //
// ./src/core/app/app-provider.service.ts